// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table[data-v-623459c0] {\n    border-collapse: collapse;\n}\n.table thead th[data-v-623459c0] {\n    background: #e4e6e8;\n    font-size: 14px;\n    font-weight: 600;\n    padding: 8px;\n    color: var(--grey-color);\n}\n.table tbody td[data-v-623459c0] {\n    font-size: 14px;\n    /*font-weight: 600;*/\n    padding: 8px;\n    color: var(--grey-color);\n    border-top: 0;\n}\n.table tbody tr[data-v-623459c0] {\n    border-bottom: 1px solid #dee2e6;\n}\n", ""]);
// Exports
module.exports = exports;
